import { useQuery } from '@tanstack/react-query'
import { sanitizeReportType } from '~components/link-tile'
import { EmissionsReportTypes } from '~pages/pages-behind-login/emissions/utils'
import { tenMinutes } from '../../../constants/constants'
import { reportTypes as reportsReportTypes } from '../../../pages/pages-behind-login/reports/content'
import { apiBase } from '../../../utils/base-url'
import { useFetch } from '../../../utils/fetch-request'

export interface ReportI {
  id: string
  name: string
  type: string
  webUrl: string
  embedUrl: string
  datasetId: string
  year?: string
}

export const reportTypes = [
  ...reportsReportTypes,
  ...Object.values(EmissionsReportTypes),
  'Voyage-Summary',
] as const

export type ReportType = (typeof reportTypes)[number]

export function usePowerBiReportsByType(type: ReportType | undefined) {
  const fetchReportsRequest = useFetch<ReportI[]>()
  const sanitizedReportType = type ? sanitizeReportType(type) : ''

  const { data, isLoading, isError } = useQuery({
    queryKey: ['/reports', sanitizedReportType],
    queryFn: () =>
      fetchReportsRequest(`${apiBase()}/reports?type=${sanitizedReportType}`),
    staleTime: tenMinutes,
    enabled: !!type,
  })

  let reports: ReportI[] | undefined
  if (data) {
    reports = data.sort((a, b) => Number(a.year) - Number(b.year))
  }

  return { data: reports, isLoading, isError }
}
